export default __webpack_public_path__ + "static/media/calculus.f5e484cd.svg";